import gql from 'graphql-tag';
export default gql`
  mutation fetchVehicleByCatalogId($searchFilters: VehicleByCatalogIdInput) {
    fetchVehicleByCatalogId(searchFilters: $searchFilters) {
      items {
        id
        referenceId
        catalogVehicleId
        quotationTemplateId
        catalogPrice
        consumerPrice
        monthLeaseprice
        weekLeaseprice
        fiscalValue
        netPrice
        discountRate
        discountAmount
        excessDistancePrice
        distance
        distanceUnit
        duration
        durationUnit
        creationDate
        leasecompany
        catalogYear
        vehicleDescription
        vehicleMake
        vehicleModel
        vehicleCategory
        vehicleNaturegroup
        cabType
        vehicleTrim
        vehicleBodystyle
        vehicleBodytype
        vehicleNrofdoors
        vehicleDrivetrain
        vehicleWheelbase
        vehicleTransmissiongroup
        vehicleTransmission
        vehiclePrimaryfueltype
        vehicleNrofseats
        vehicleFueltype
        brokerId
        brokerName
        imagespath
        imagespathDrive
        imagespathBody
        imagespathTrim
        jatoImagepath
        jatoImagepathBase
        jatoImagepathTrim
        marketingSubject
        marketingBodyText
        fuelConsumption
        coEmission
        maxLoad
        trailerLoadBraked
        serviceSchedule
        engineKw
        engineCc
        vehicleNrofcylinders
        tankCapacity
        vehicleWarranty
        vehicleNrofpassengers
        vehicleFinance
        vehicleFinanceWeekly
        vehicleRunningCost
        vehicleRunningCostWeekly
        quoteRefId
        ancapRating
      }
      variants {
        id
        referenceId
        catalogVehicleId
        quotationTemplateId
        catalogPrice
        consumerPrice
        monthLeaseprice
        weekLeaseprice
        fiscalValue
        netPrice
        discountRate
        discountAmount
        excessDistancePrice
        distance
        distanceUnit
        duration
        durationUnit
        creationDate
        leasecompany
        catalogYear
        vehicleDescription
        vehicleMake
        vehicleModel
        vehicleCategory
        vehicleNaturegroup
        cabType
        vehicleTrim
        vehicleBodystyle
        vehicleBodytype
        vehicleNrofdoors
        vehicleDrivetrain
        vehicleWheelbase
        vehicleTransmissiongroup
        vehicleTransmission
        vehiclePrimaryfueltype
        vehicleNrofseats
        vehicleFueltype
        brokerId
        brokerName
        imagespath
        imagespathDrive
        imagespathBody
        imagespathTrim
        jatoImagepath
        jatoImagepathBase
        jatoImagepathTrim
      }
    }
  }
`;
